import AdminProfileIcon from './component'

export default AdminProfileIcon
